import { Palette, Moon, ScanEye, ShieldCheck, Server, Save } from 'lucide-react';
import SeriesTemplate from '../components/SeriesTemplate';

const SuperColorVu = () => {
  const features = [
    {
      Icon: Palette,
      title: '夜間もカラー映像で確認',
      desc: '低照度環境でも色情報を保持し、服装・車両の色などを分かりやすく記録できます。',
    },
    {
      Icon: Moon,
      title: '暗所でも視認性の高い映像',
      desc: '感度の高いセンサーとレンズにより、夜間の外周や駐車場の映像を確認しやすく残します。',
    },
    {
      Icon: ScanEye,
      title: '人・車両検知',
      desc: '人や車両の検知に対応し、必要な確認や録画管理をサポートします。',
    },
    {
      Icon: ShieldCheck,
      title: '屋外設置に対応',
      desc: 'IP66対応モデルがあり、屋外の駐車場・外周・施設まわりにも使用できます。',
    },
    {
      Icon: Server,
      title: 'NVR・録画機器と連携',
      desc: 'カメラ台数、録画日数、保存容量に合わせて録画機器を選定できます。',
    },
    {
      Icon: Save,
      title: '顔認識機能対応モデル',
      desc: '検知ログや通知連携を活用したい現場に向いています。',
    },
  ];

  const notes = [
    '夜間のカラー再現は、周囲の光量・設置位置・対象物までの距離により異なります。',
    '街灯や照明の少ない環境では、補助照明との併用をご相談ください。',
    '屋外設置の場合は、配線経路・取付位置・防水処理の確認が必要です。',
    '機種や設定内容により、使用できる機能が異なる場合があります。',
  ];

  return (
    <SeriesTemplate
      id="colorvu"
      eyebrow="NIGHT COLOR"
      name="Super ColorVuカメラシリーズ"
      description="暗い場所でも色のある映像を確認しやすい防犯カメラシリーズです。夜間の状況を分かりやすく残したい現場に適しています。"
      tags={['夜間カラー', '4MP / 8MP', 'PoE対応', 'IP66', '顔認識対応', '遠隔確認']}
      heroImage="/images/super-colorvu.png"
      features={features}
      locations={['店舗外周', '駐車場', '夜間監視', '車両出入口', '施設まわり', '倉庫まわり']}
      notes={notes}
    />
  );
};

export default SuperColorVu;
